import { Theme } from '@mui/material';

export const getMenuItemStyles = () => ({
  fontSize: '16px !important',
});

export const getErrorLabelStyles = (theme: Theme) => ({
  color: theme.palette.error.main,
});
